import PowerSlider from './power-slider';
import PowerChart from './power-chart';

let sliders: PowerSlider[];

onload = () => {
    sliders = new Array(24);
    document.querySelectorAll("power-slider[data-index]").forEach(slider => {
        let index = parseInt(slider.getAttribute("data-index") ?? "0");
        sliders[index] = slider as PowerSlider;
    });

    var chart = document.getElementById("chart") as PowerChart;

    sliders.forEach(elem => {
        const slider = elem as PowerSlider;
        const index = parseInt(slider.getAttribute("data-index") ?? "0");

        slider.addEventListener("input", () => {
            chart.setValue(index, slider.value);
        });
    });

    let suppressHashChange = false;
    let invalidateHash = false;

    chart.addEventListener("chart-changed", (e: CustomEvent<number>) => {
        sliders[e.detail].value = chart.getValue(e.detail);
        invalidateHash = true;
        updatePointTotal();
    });

    let fineTuneBtn = document.getElementById("toggleFineTune") as HTMLButtonElement;
    fineTuneBtn.addEventListener("click", () => {
        chart.roundToTenth = !chart.roundToTenth;
        fineTuneBtn.textContent = chart.roundToTenth ? "Enable Fine Tuning" : "Disable Fine Tuning";
        sliders.forEach(slider => slider.step = chart.roundToTenth ? 0.1 : 0.01);
        updatePointTotal();
    });

    let clearBtn = document.getElementById("clearValues") as HTMLButtonElement;
    clearBtn.addEventListener("click", () => {
        for (let i = 0; i < 24; ++i)
            chart.setValue(i, 0);
    });

    let toggleBtn = document.getElementById("toggleDescriptions") as HTMLButtonElement;
    let shown = true;
    toggleBtn.addEventListener("click", () => {
        shown = !shown;
        toggleBtn.textContent = shown ? "Hide Descriptions" : "Show Descriptions";
        sliders.forEach(slider => slider.toggleDescription());
    });

    function updateHash() {
        if (!invalidateHash) return;
        suppressHashChange = true;
        history.replaceState(null, "", "#" + chart.serialize());
        suppressHashChange = false;
    }

    function loadFromHash() {
        let hash = window.location.hash;
        if (hash.startsWith("#")) {
            chart.deserialize(hash.slice(1));
            if (!chart.roundToTenth) {
                sliders.forEach(slider => slider.step = 0.01);
                fineTuneBtn.textContent = "Disable Fine Tuning";
            }
        }
    }

    function updatePointTotal() {
        let total = 0;
        for (let i = 0; i < 24; ++i)
            total += chart.getValue(i);
        let label = document.getElementById("pointTotal");
        if (label) label.textContent = (total * 10).toFixed(chart.roundToTenth ? 0 : 1)
    }

    loadFromHash();

    window.addEventListener("hashchange", () => {
        if (suppressHashChange) return;
        loadFromHash();
    });

    setInterval(updateHash, 500);
};

customElements.define('power-slider', PowerSlider);
customElements.define('power-chart', PowerChart);
